import script from "./QModal.vue?vue&type=script&setup=true&lang=js"
export * from "./QModal.vue?vue&type=script&setup=true&lang=js"

import "./QModal.vue?vue&type=style&index=0&id=4ead7bbf&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ead7bbf"]])

export default __exports__